'use client';

import type { ProductCard } from '@repo/shopify';
import { useState } from 'react';
import { ProductGridClient } from '@/components/product/product-grid-client';
import { getSectionSpacing } from './section-spacing';

type Tab = {
	label: string;
	products: ProductCard[];
	ratings: (number | null)[];
	reviewCounts: (number | null)[];
};

export function TabbedProductsClient({
	heading,
	sectionId,
	tabs,
	enableReviews = false,
	moneyLocale,
	sectionSpacing,
}: {
	heading?: string;
	sectionId?: string;
	tabs: Tab[];
	enableReviews?: boolean;
	moneyLocale?: string;
	sectionSpacing?: string;
}) {
	const [activeIndex, setActiveIndex] = useState(0);
	const activeTab = tabs[activeIndex] || tabs[0];

	if (!activeTab) return null;

	return (
		<section
			id={sectionId}
			className={getSectionSpacing(sectionSpacing, { hasHeader: Boolean(heading) })}
		>
			<div className="container-page">
				{heading && <h2 className="mb-6 text-3xl font-black tracking-tight">{heading}</h2>}
				<div className="mb-6 flex flex-wrap gap-2">
					{tabs.map((tab, index) => (
						<button
							key={tab.label}
							type="button"
							onClick={() => setActiveIndex(index)}
							className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${index === activeIndex ? 'bg-neutral-900 text-white' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'}`}
						>
							{tab.label}
						</button>
					))}
				</div>
				<ProductGridClient
					products={activeTab.products}
					columns={4}
					showQuickAdd
					enableReviews={enableReviews}
					moneyLocale={moneyLocale}
					ratings={activeTab.ratings}
					reviewCounts={activeTab.reviewCounts}
				/>
			</div>
		</section>
	);
}
